import React from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import InfluenceSurveyLayout from './influence-survey-layout';

class InfluenceSurveyComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render = () => {
        ReactDOM.render(
            <InfluenceSurveyLayout options={this.options} />,
            this.element
        );
    }
}

export default InfluenceSurveyComponent;
